// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const IpfilterTrafficType = {
  TrafficTypePublicOnly: 'PublicOnly',
  TrafficTypeHybrid: 'Hybrid',
  TrafficTypePrivateOnly: 'PrivateOnly',
} as const;
export type IpfilterTrafficType =
  (typeof IpfilterTrafficType)[keyof typeof IpfilterTrafficType];

export function instanceOfIpfilterTrafficType(value: any): boolean {
  for (const key in IpfilterTrafficType) {
    if (Object.prototype.hasOwnProperty.call(IpfilterTrafficType, key)) {
      if (
        IpfilterTrafficType[key as keyof typeof IpfilterTrafficType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function IpfilterTrafficTypeFromJSON(json: any): IpfilterTrafficType {
  return IpfilterTrafficTypeFromJSONTyped(json, false);
}

export function IpfilterTrafficTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IpfilterTrafficType {
  return json as IpfilterTrafficType;
}

export function IpfilterTrafficTypeToJSON(
  value?: IpfilterTrafficType | null,
): any {
  return value as any;
}

export function IpfilterTrafficTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): IpfilterTrafficType {
  return value as IpfilterTrafficType;
}
